<template>
  <div
    v-if="showCompontent"
    class="recommendPosition_wrap"
    :style="{ backgroundImage: `url(${moduleIconUrl})` }"
  >
    <div class="header">
      <span
        class="header_title"
        :style="{
          textShadow: `0px 2px 8px ${buttonColor}`,
        }"
        >{{ componentConfig?.title }}</span
      >
      <span
        class="header_desc"
        :style="{ textShadow: `0px 2px 8px ${buttonColor}` }"
        >{{ componentConfig?.subtitle }}</span
      >
    </div>
    <div class="content" v-if="loading && jobList?.length === 0 || nearbyPopShow">
      <div class="empty" :class="isForPC&&'empty_pc'" v-for="(e, eI) in 2" :key="eI">
        <div class="skeleton"></div>
      </div>
    </div>
    <job-nearby v-else-if="jobNeedNearby && !loading" />
    <Empty v-else-if="!loading && jobList?.length === 0" />
    <template v-else>
      <van-list
        v-model="loading"
        :immediate-check="false"
        :finished="finished||moreListLen>0"
        :error.sync="jobError"
        loading-text="正在加载…"
        error-text="请求失败，点击重新加载"
        @load="moreListLen==0?queryJobList(1):''"
      >
        <div
          class="job_item_wrap sensors_exposure"
          v-for="(item, index) in jobListData.list.slice(0,topListLen)"
          sensorsname="JobShortExposure"
          :sensorsdata="
            $base.getJobShortExposureData(item, index, getExtraParams(item))
          "
          :key="index"
        >
          <div class="job_item" @click="goJobDetail(item, index)">
            <div class="job_item_top">
              <template
                v-if="
                  componentConfig?.rankingStyle && index <= jobListData.index
                "
              >
                <div v-if="index <= 2" class="top_icon">
                  <img
                    :src="require(`@/assets/img/activity/top${index + 1}.png`)"
                    alt=""
                  />
                </div>
                <div v-if="index > 2 && index < 50" class="top_num_icon">
                  <img src="@/assets/img/activity/hand@2x.png" alt="" />
                  <span>TOP {{ index + 1 }}</span>
                </div>
              </template>
              <div class="job_header">
                <span>{{ item.jobName }}</span>
                <span v-if="item.provideSalaryString">
                  {{ item.provideSalaryString }}
                </span>
              </div>
              <div class="job_tag_wrap">
                <div class="tag_div" v-if="item.jobTags?.length > 0">
                  <span
                    v-for="(tag, tkey) in item.jobTags"
                    :key="tkey"
                    :style="{ display: !tag ? 'none' : 'block' }"
                    >{{ tag }}</span
                  >
                </div>
              </div>
              <div class="company_info">
                <div v-if="item.companyName" class="company_info_comname">
                  <span>{{ item.companyName }}</span>
                </div>
                <span v-if="item.companyTypeString">{{
                  item.companyTypeString
                }}</span>
                <span v-if="item.companySizeString">{{
                  item.companySizeString
                }}</span>
              </div>
              <div class="hr_info" v-if="!item.billboardReason">
                <div class="avatar">
                  <img
                    v-if="item.smallHrLogoUrl"
                    :src="item.smallHrLogoUrl"
                    alt=""
                  />
                  <img
                    v-else
                    :src="
                      require(`@/assets/img/activity/${
                        item.isFromXyx ? 'message_hr_fromxy' : 'message_hr_def'
                      }.png`)
                    "
                  />
                </div>
                <div class="onlineStatus" v-if="item.isOnline"></div>
                <span class="name1" v-if="item.isFromXyx">应届生网申职位</span>
                <span class="name" v-else>{{ item.hrName || "HR" }}</span>
                <span class="status">
                  {{ item.hrLabels ? item.hrLabels[0] : "" }}
                </span>
              </div>
              <div class="hr_and_btn" :style="{marginTop: item.billboardReason ? '8px':'0px'}">
                <div class="address">
                  {{
                    item.workAreaCode != "999999"
                      ? item.jobAreaString
                      : "远程办公"
                  }}
                </div>
                <div class="btn_wrap">
                  <template v-if="item.isFromXyx || !platform.includes('App')">
                    <div
                      class="main"
                      :class="{ sended: item.isApply }"
                      @click.stop="btnClick(item, 2)"
                    >
                      <img
                        src="@/assets/img/activity/send-white@2x.png"
                        alt=""
                        v-if="!item.isApply"
                      />
                      <span>{{ item.isApply ? "已投递" : "投递" }}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="secondary"
                      :class="{
                        sended: item.isApply && btnObj.secondBtn === 2,
                      }"
                      @click.stop="btnClick(item, btnObj.secondBtn)"
                    >
                      <img
                        src="@/assets/img/activity/send@2x.png"
                        alt=""
                        v-if="btnObj.secondBtn === 2 && !item.isApply"
                      />
                      <span>{{
                        btnObj.secondBtn === 1
                          ? "去聊聊"
                          : item.isApply
                          ? "已投递"
                          : "投递"
                      }}</span>
                    </div>
                    <div
                      class="main"
                      :class="{ sended: item.isApply && btnObj.mainBtn === 2 }"
                      @click.stop="btnClick(item, btnObj.mainBtn)"
                    >
                      <img
                        src="@/assets/img/activity/send-white@2x.png"
                        alt=""
                        v-if="btnObj.mainBtn === 2 && !item.isApply"
                      />
                      <span>{{
                        btnObj.mainBtn === 1
                          ? "去聊聊"
                          : item.isApply
                          ? "已投递"
                          : "投递"
                      }}</span>
                    </div>
                  </template>
                </div>
              </div>
              <div class="rank-reason" v-if="index < 50 &&  item.billboardReason">
                <img src="@/assets/img/activity/rank-reason-icon.png" alt="">
                <div class="rank-reason-des" v-html="item.billboardReason">
                </div>
              </div>
            </div>
            <div
              class="job_question_and_answer"
              v-if="
                componentConfig?.showThread === 1 &&
                !item.isFromXyx &&
                item?.questionList
              "
            >
              <div
                class="noquestion"
                v-if="item?.questionList?.length === 0"
                @click.stop="toQuestion(item)"
              >
                <div>
                  <img src="@/assets/img/activity/qabg1@3x.png" alt="" />
                  <span>听听同行怎么说，去提问</span>
                </div>
                <img src="@/assets/img/activity/icon-right@3x.png" alt="" />
              </div>
              <div class="hasquestion" v-else @click.stop="toqaList(item)">
                <div
                  class="question_info"
                  v-for="item in item.questionList"
                  :key="item.id"
                >
                  <div class="answer_info">
                    <img src="@/assets/img/activity/qabg1@3x.png" alt="" />
                    <span>{{ item?.description }}</span>
                  </div>
                  <div class="answer_num">
                    <span>{{ answerNum(item?.answerTotalCount) }}</span>
                    <img src="@/assets/img/activity/right@2x.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <div class="moreRecommend" v-if="moreListLen>0 && !alwaysFilterFlag2">
        <img :src="pageConfig.jobIconUrl" alt="" />
      </div>
      <van-list
        v-model="loading"
        :immediate-check="false"
        :finished="finished||moreListLen==0"
        :error.sync="jobError"
        loading-text="正在加载…"
        error-text="请求失败，点击重新加载"
        @load="moreListLen>0?queryJobList(2):''"
      >
        <div
          class="job_item_wrap sensors_exposure"
          v-for="(item, index) in jobListData.list.slice(topListLen)"
          sensorsname="JobShortExposure"
          :sensorsdata="
            $base.getJobShortExposureData(item, index, getExtraParams(item))
          "
          :key="index"
        >
          <div class="job_item" @click="goJobDetail(item, index)">
            <div class="job_item_top">
              <!-- <template
                v-if="
                  componentConfig?.rankingStyle && index <= jobListData.index
                "
              >
                <div v-if="index <= 2" class="top_icon">
                  <img
                    :src="require(`@/assets/img/activity/top${index + 1}.png`)"
                    alt=""
                  />
                </div>
                <div v-if="index > 2 && index < 20" class="top_num_icon">
                  <img src="@/assets/img/activity/hand@2x.png" alt="" />
                  <span>TOP {{ index + 1 }}</span>
                </div>
              </template> -->
              <div class="job_header">
                <span>{{ item.jobName }}</span>
                <span v-if="item.provideSalaryString">
                  {{ item.provideSalaryString }}
                </span>
              </div>
              <div class="job_tag_wrap" v-if="item.jobTags?.length > 0">
                <div class="tag_div">
                  <span
                    v-for="(tag, tkey) in item.jobTags"
                    :key="tkey"
                    :style="{ display: !tag ? 'none' : 'block' }"
                    >{{ tag }}</span
                  >
                </div>
              </div>
              <div class="company_info">
                <div v-if="item.companyName" class="company_info_comname">
                  <span>{{ item.companyName }}</span>
                </div>
                <span v-if="item.companyTypeString">{{
                  item.companyTypeString
                }}</span>
                <span v-if="item.companySizeString">{{
                  item.companySizeString
                }}</span>
              </div>
              <div class="hr_info">
                <div class="avatar">
                  <img
                    v-if="item.smallHrLogoUrl"
                    :src="item.smallHrLogoUrl"
                    alt=""
                  />
                  <img
                    v-else
                    :src="
                      require(`@/assets/img/activity/${
                        item.isFromXyx ? 'message_hr_fromxy' : 'message_hr_def'
                      }.png`)
                    "
                  />
                </div>
                <div class="onlineStatus" v-if="item.isOnline"></div>
                <span class="name1" v-if="item.isFromXyx">应届生网申职位</span>
                <span class="name" v-else>{{ item.hrName || "HR" }}</span>
                <span class="status">
                  {{ item.hrLabels ? item.hrLabels[0] : "" }}
                </span>
              </div>
              <div class="hr_and_btn">
                <div class="address">
                  {{
                    item.workAreaCode != "999999"
                      ? item.jobAreaString
                      : "远程办公"
                  }}
                </div>
                <div class="btn_wrap">
                  <template v-if="item.isFromXyx || !platform.includes('App')">
                    <div
                      class="main"
                      :class="{ sended: item.isApply }"
                      @click.stop="btnClick(item, 2)"
                    >
                      <img
                        src="@/assets/img/activity/send-white@2x.png"
                        alt=""
                        v-if="!item.isApply"
                      />
                      <span>{{ item.isApply ? "已投递" : "投递" }}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="secondary"
                      :class="{
                        sended: item.isApply && btnObj.secondBtn === 2,
                      }"
                      @click.stop="btnClick(item, btnObj.secondBtn)"
                    >
                      <img
                        src="@/assets/img/activity/send@2x.png"
                        alt=""
                        v-if="btnObj.secondBtn === 2 && !item.isApply"
                      />
                      <span>{{
                        btnObj.secondBtn === 1
                          ? "去聊聊"
                          : item.isApply
                          ? "已投递"
                          : "投递"
                      }}</span>
                    </div>
                    <div
                      class="main"
                      :class="{ sended: item.isApply && btnObj.mainBtn === 2 }"
                      @click.stop="btnClick(item, btnObj.mainBtn)"
                    >
                      <img
                        src="@/assets/img/activity/send-white@2x.png"
                        alt=""
                        v-if="btnObj.mainBtn === 2 && !item.isApply"
                      />
                      <span>{{
                        btnObj.mainBtn === 1
                          ? "去聊聊"
                          : item.isApply
                          ? "已投递"
                          : "投递"
                      }}</span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div
              class="job_question_and_answer"
              v-if="
                componentConfig?.showThread === 1 &&
                !item.isFromXyx &&
                item?.questionList
              "
            >
              <div
                class="noquestion"
                v-if="item?.questionList?.length === 0"
                @click.stop="toQuestion(item)"
              >
                <div>
                  <img src="@/assets/img/activity/qabg1@3x.png" alt="" />
                  <span>听听同行怎么说，去提问</span>
                </div>
                <img src="@/assets/img/activity/icon-right@3x.png" alt="" />
              </div>
              <div class="hasquestion" v-else @click.stop="toqaList(item)">
                <div
                  class="question_info"
                  v-for="item in item.questionList"
                  :key="item.id"
                >
                  <div class="answer_info">
                    <img src="@/assets/img/activity/qabg1@3x.png" alt="" />
                    <span>{{ item?.description }}</span>
                  </div>
                  <div class="answer_num">
                    <span>{{ answerNum(item?.answerTotalCount) }}</span>
                    <img src="@/assets/img/activity/right@2x.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </template>
    <div class="see_more" v-if="!isLastComponent && pageNum !== 1">
      <div
        v-if="!loading && pageNum <= totalPages && !jobNeedNearby"
        @click="seeMoreFun"
        class="see_more_btn"
      >
        <span>查看更多</span>
        <img src="@/assets/img/activity/down@3x.png" alt="" />
      </div>
      <div v-if="loading">
        <img
          src="@/assets/img/activity/loading@2x.png"
          alt=""
          class="loading_img"
        />
        <span>正在加载…</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions} from "vuex";
import Empty from "../common/EmptyData.vue";
import JobNearby from "@/components/Nearby/JobNearby.vue"
export default {
  name: "JobListSingleSide",
  components: {
    Empty,JobNearby
  },
  props: {
    componentConfig: {
      type: Object,
      default: () => {},
    },
    pageConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showCompontent: true,
      alwaysFilterFlag2: false,
      loading: true,
      finished: false,
      jobError: false,
      pageNum: 1,
      requestId: "",
      jobOrCompanyIdList: [],
      jobList: [],
      totalPages: 0,
      isFirstInit:false,
      topListLen: 0,
      moreListLen: 0,
      mm:` <span>上榜理由：该职位最近被<span style="color: #FF6C0E;font-weight:500">480</span>个同行搜索过！</span>`
    };
  },
  computed: {
    ...mapState(["commonStore","resumeStore"]),
    jobNeedNearby: {
      get() {
        console.log(this.componentConfig.jobContentDTO?.showCondition,'showCondition');
        return this.componentConfig.jobContentDTO?.showCondition==1 && !this.commonStore.lon;
      },
      set() {},
    },
    nearbyPopShow: {
      get() {
        return this.commonStore.nearbyPopShow;
      },
      set() {},
    },
    platform() {
      return this.commonStore.platform;
    },
    isForPC() {
      return this.commonStore.isForPC;
    },
    backgroundConfigDTO(){
      return this.componentConfig.backgroundConfigDTO
    },
    buttonColor(){
      return this.backgroundConfigDTO?.buttonColor||this.pageConfig.buttonColor
    },
    moduleIconUrl(){
      if(this.commonStore.isForPC){
        return this.backgroundConfigDTO?.moduleIconPcUrl||this.pageConfig.moduleIconPcUrl
      }else{
        return this.backgroundConfigDTO?.moduleIconUrl||this.pageConfig.moduleIconUrl
      }
    },
    btnObj() {
      const map = {
        1: 2,
        2: 1,
      };
      return {
        mainBtn: this.componentConfig?.buttonType,
        secondBtn: map[this.componentConfig?.buttonType],
      };
    },
    jobListData() {
      const list1 = [];
      const list2 = [];
      this.jobList.forEach((item, index) => {
        if (item.jobFilterFlag === 1 || item.jobFilterFlag === 3) {
          list1.push(item);
        } else {
          list2.push(item);
        }

        if (index == 0 && item.jobFilterFlag === 2) {
          this.alwaysFilterFlag2 = true
        }
      });
      this.topListLen = list1.length
      this.moreListLen =  list2.length
      console.log(this.topListLen,this.moreListLen,'moreListLen');
      if (list1.length > 0 && list2.length > 0) {
        return {
          list: [...list1, ...list2],
          index: list1.length - 1,
        };
      }
      return {
        list: [...list1, ...list2],
        index: list1.length + list2.length,
      };
    },
    isLastComponent() {
      return this.pageConfig?.lastComponentId === this.componentConfig?.id;
    },
    needFilterJobs(){//是否当前组件需配置了推荐
      if( !!this.componentConfig?.jobContentDTO?.billboardType){  // 榜单数据源不需要去重
        return false;
      }else if(this.componentConfig.recommendConfigDTO){
        return this.componentConfig.recommendConfigDTO.needFilterJobs;
      }else if(this.pageConfig.recommendConfigDTO && this.pageConfig.recommendConfigDTO.needFilterJobs){
        return true;
      }else{
        return false;
      }
    },
    strategyId() {
      return this.componentConfig?.jobContentDTO?.strategyId || ''
    }
  },
  watch: {
    "commonStore.currentAreaCode": {
      handler(newVal) {
        if (!newVal) return;
        this.isFirstInit = false;
        this.loading = true;
        this.jobError = false;
        this.pageNum = 1;
        this.requestId = "";
        this.jobOrCompanyIdList = [];
        this.jobList = [];
        if (!this.isLastComponent) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.queryJobList();
      },
      immediate: false,
    },
    "commonStore.deweightComponentSort":{//监控去重顺序变更
      handler(val) {
        if(val == this.componentConfig.deWeightSort){//轮到本组件加载数据了
          console.log("触发-----监控去重-----顺序变更33333",val)
          this.isFirstInit = true;
          if (!this.isLastComponent) {
            this.finished = true;
          }
          console.log("触发-----职位单列组件-----顺序",this.componentConfig.deWeightSort);
          this.queryJobList();
        }
      },
      immediate: false,
    }
  },
  mounted() {
    // sessionStorage.removeItem("filterJobIds");
    // if (!this.isLastComponent) {
    //   this.finished = true;
    // }
    // console.log("触发职位单列组件顺序",this.componentConfig.sort);
    // this.queryJobList();
  },
  methods: {
    ...mapActions("applyJobStore", ["applyJob", "batchApplyJob"]),
    // 职位列表
    async queryJobList(i) {
       console.log("单列：needFilterJobs",this.needFilterJobs)
      // alert(i)
      if (this.finished && this.isLastComponent) return;
      if (!this.isLastComponent) {
        this.loading = true;
      }
      const params = {
        componentId: this.componentConfig?.id,
        cityCode: this.commonStore?.currentAreaCode || this.commonStore?.intention?.expectArea || '000000',
        funcCode: this.$route.query?.funcCode
          ? this.$route.query.funcCode
          : this.commonStore.intention?.expectFunction || "",
        requestId: this.requestId,
        jobOrCompanyIdList: this.jobOrCompanyIdList,
        pageNum: this.pageNum,
        pageSize: this.componentConfig?.jobNumber,
        workFuncStr: this.commonStore.intention?.expectFunctionString,
        expectWorkArea: this.commonStore.intention?.expectArea,
        expectIndustry: this.commonStore.intention?.expectIndustry,
        expectIndustryNew: this.commonStore.intention?.expectIndustry,
        expectMinSalary: this.commonStore.intention?.minSalary,
        expectMaxSalary: this.commonStore.intention?.maxSalary,
        busBelong: this.pageConfig.busBelong || "51job",
        seekType: this.commonStore.intention?.seekType || "",
        userIdentity:
          this.commonStore.identityType == "职场人"
            ? 0
            : this.commonStore.identityType == "在校生"
            ? 1
            : 0,
        degree:this.resumeStore.resume?.c.education[0]?.degree || '',
        major:this.resumeStore.resume?.c.education[0]?.major || '',
        filterJobIds:(this.isFirstInit && this.needFilterJobs) ? (JSON.parse(sessionStorage.getItem("filterJobIds"))|| null):null,//过滤ids  
        resideCity:this.resumeStore.resume?.accountInfo?.area || '',
        lon: this.commonStore.lon || '',
        lat: this.commonStore.lat || '',
        radius: this.commonStore.radius || '',
      };
      const property = {
        pageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.strategyId}`,
        shortPageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.strategyId}`,
        requestId: this.requestId,
        pageNum: this.pageNum,
      };
      const res = await this.$api.activity.getActivityJobList(params, {
        property,
      });
      // 首屏去重职位逻辑:请求完数据,加载下一个需要去重的组件
      if(this.isFirstInit){//首次加载数据
        this.isFirstInit = false;
        this.$base.setFilterJobIds(this.componentConfig.deWeightSort,res.data?.jobInfoList?.result);
      }
      if (+res?.code == "0") {
        const {
          requestId,
          jobOrCompanyIdList,
          jobInfoList: { result = [], totalPages } = {},
        } = res.data;

        if (!result?.length && this.pageNum == 1) {
          this.showCompontent = false
          this.$store.commit('subCountJobAndCompany')
        }
        
        this.requestId = requestId;
        this.jobOrCompanyIdList = jobOrCompanyIdList;
        if (this.componentConfig?.showThread === 1 && result?.length > 0) {
          const newResult = await this.getQuestionList(result);
          this.jobList.push(...newResult);
        } else {
          this.jobList.push(...result);
        }
        this.$nextTick(() => {
          this.$exposure.sensorsExposure();
        });
        this.totalPages = totalPages;
        this.pageNum++;
        this.loading = false;
        if (this.pageNum > totalPages && this.isLastComponent) {
          this.finished = true;
        }
      } else {
        this.jobError = true;
        this.loading = false;
      }
    },
    async getQuestionList(data) {
      const params = {
        componentId: this.componentConfig?.id,
        pageSize: 1,
        pageNum: 1,
        jobIdList: data.map(({ jobId }) => jobId),
        type: 3,
        sortType: [2, 1],
      };
      const res = await this.$api.activity.getQuestionList(params);
      if (+res?.code == "0" && res?.data) {
        const { questionMap = {} } = res.data || {};
        const result = data.map((item) => {
          const { questionInfoList } = questionMap[item.jobId] || {};
          return {
            ...item,
            questionList: questionInfoList || [],
          };
        });
        return result;
      } else {
        return data;
      }
    },
    toApply(item) {
      if (item.isApply) return;
      if (item.isFromXyx) {
        this.goJobDetail(item);
        return;
      }
      // 单投
      const property = (item?.property && JSON.parse(item.property)) || {};
      const params = {
        item: { ...item, jobId: String(item.jobId) },
        property: {
          ...property,
          fromModule: "列表单投",
        },
        isShowToast: "0",
        onSuccess: () => {
          this.$emit("goQuestionSet", [item]);
          this.changeItemIsApply(item);
          this.$store.commit("setValueLocalStorage", {
            applyJobRefreshTasks:
              this.$store.state.commonStore.applyJobRefreshTasks + 1,
          });
        },
      };
      this.applyJob(params);
    },
    // 投递成功后按钮展示已投递
    changeItemIsApply(item) {
      this.jobList.find((job) => job.jobId === item.jobId).isApply = true;
    },
    toChat(item) {
      this.$base.goChatNew(item, this.commonStore, {
        pageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
      });
    },
    //按钮点击
    btnClick(item, type) {
      if (!this.$base.checkLoginStatus(true)) return;
      if (type === 1) {
        // 去聊聊
        this.toChat(item);
      } else {
        // 投递
        this.toApply(item);
      }
    },
    //跳转职位详情
    goJobDetail(item, index) {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_joblist",
        moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
        contentName: this.componentConfig.title,
        contentType: "职位",
        contentId: item.jobId,
        contentRank: `${index}`,
        bcopExrinfo: {
          pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.strategyId}`,
        },
      });

      if (!this.$base.checkLoginStatus(true)) return;
      this.$base.toJobDetail(item, index);
    },
    seeMoreFun() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_joblist_more",
        moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
        contentName: this.componentConfig.title,
        bcopExrinfo: {
          pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.strategyId}`,
        },
      });
      this.queryJobList();
    },
    toQuestion(item) {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_joblist_askbanner",
        moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
        contentName: this.componentConfig.title,
        bcopExrinfo: {
          pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.strategyId}`,
        },
      });

      if (!this.$base.checkLoginStatus(true)) return;

      this.$router.push({
        path: "/askQuestion",
        query: {
          jobId: item.jobId,
          jobName: item.jobName,
          provideSalaryString: item.provideSalaryString,
          coId: item.coId,
          coName: item.fullCompanyName,
          activityId: this.$route.params.pageId,
          type: 3,
          componentId: this.componentConfig?.id,
          ctmId: item.ctmId,
        },
      });
    },
    toqaList(item) {
      if (!this.$base.checkLoginStatus(true)) return;
      // 1-活动下的问答；2-公司下的问答；3-职位下的问答
      this.$router.push({
        path: "/questionAndAnswerList",
        query: {
          id: item.jobId,
          activityId: this.$route.params.pageId,
          componentId: this.componentConfig?.id,
          type: 3,
        },
      });
    },
    getExtraParams(item) {
      const ehrData = {
        isQAShow:
          this.componentConfig?.showThread === 1 &&
          !item.isFromXyx &&
          item.questionList
            ? "是"
            : "否",
        isPostShow: item.questionList?.length > 0 ? "是" : "否",
        contentId: item.questionList
          ? item.questionList.map((item) => item.id).join("_")
          : "",
      };
      return {
        exrInfo: JSON.stringify(ehrData),
      };
    },
    answerNum(num) {
      if (!num) return "暂无回答";
      if (num > 99) {
        return "共99+个回答";
      } else {
        return `共${num}个回答`;
      }
    },
  },
};
</script>
<style src="./index.less" scoped lang="less" />
